import React, { useMemo, useRef, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import ReCAPTCHA from 'react-google-recaptcha';
import { FaEyeSlash, FaEye } from 'react-icons/fa';
import { Button, Form, Modal } from 'react-bootstrap';

import styles from './ResetarSenha.module.css';
import editPassword from '../../api/editPassword';

const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

const ResetarSenha = () => {
  const history = useHistory();
  const [error, setError] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showEye, setShowEye] = useState(false);

  const initialValues = {
    password: '',
    confirmPassword: ''
  };

  const [values, setValues] = useState(initialValues);

  const captchaRef = useRef(null);
  const [recaptchaToken, setRecaptchaToken] = useState(null);
  const handleRecaptcha = () => setRecaptchaToken(captchaRef.current.getValue());

  const setValue = (key, value) => {
    setValues({
      ...values,
      [key]: value
    });
  };

  const handleChange = e => {
    setValue(e.target.getAttribute('name'), e.target.value);
  };

  const handleEye = () => {
    setShowEye(!showEye);
  };

  const handleModalClose = () => {
    setShowModal(false);
  };

  const useQuery = () => {
    const { search } = useLocation();

    return useMemo(() => new URLSearchParams(search), [search]);
  };

  let query = useQuery();

  let token = query.get('token');

  const handleSubmit = e => {
    e.preventDefault();

    if (values.password !== values.confirmPassword) {
      setError('As senhas não conferem');

      setShowModal(true);

      return;
    }
      
    if (!values.password.match(/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/)) {
      setError('A senha deve ter no mínimo 8 caracteres, sendo no mínimo 1 letra maiúscula, 1 letra minúscula, 1 número e 1 caractere especial @$!%*#?&');

      setShowModal(true);

      return;
    }

    try {
      const confirmToken = async () => {
        const res = await editPassword(token, values.password, recaptchaToken);

        if (res?.error) {
          setError(res?.error);
          setShowModal(true);

          return;
        }

        history.push({
          pathname: '/login',
          state: { isNewPassword: true }
        });
      };

      confirmToken();
    } catch (error) {
      console.log(error);
    } finally { 
      captchaRef?.current?.reset();
      setRecaptchaToken(null);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.form_container}>
        <div className={styles.logo}>
          <div>
            <img src="../assets/img/fesaude-logo2.png" alt="Logo FeSaúde" />
          </div>
          <div>
            <h1 className={styles.title}>Nova Senha</h1>
            <p className={styles.form_password}>
              A senha deve ter no mínimo 8 caracteres, <br />
              sendo no mínimo 1 letra maiúscula, 1 letra minúscula, <br />
              1 número e 1 caractere especial @ $ ! % * # ? &
            </p>
          </div>
        </div>
        <Form onSubmit={handleSubmit} noValidate>
          <div className={styles.form}>

            <div className={styles.input_container}>
              <div className={styles.label_float}>
                <Form.Group controlId="password">
                  <Form.Label>*Senha:</Form.Label>
                  <div className={styles.eye_container}>
                    <Form.Control
                      className={styles.input}
                      type={showEye ? 'text' : 'password'}
                      required
                      name="password"
                      onChange={handleChange}
                      value={values.password}
                    />

                    {showEye && (
                      <FaEyeSlash className={styles.eye} onClick={handleEye} />
                    )}

                    {!showEye && (
                      <FaEye className={styles.eye} onClick={handleEye} />
                    )}
                  </div>

                  <Form.Control.Feedback type="invalid">
                    *Senha obrigatória
                  </Form.Control.Feedback>
                </Form.Group>
              </div>

              <div className={styles.label_float}>
                <Form.Group controlId="confirmPassword">
                  <Form.Label>*Repita a Senha:</Form.Label>
                  <Form.Control
                    className={styles.input}
                    type={showEye ? 'text' : 'password'}
                    required
                    name="confirmPassword"
                    onChange={handleChange}
                    value={values.confirmPassword}
                  />
                </Form.Group>
                
                <Modal show={showModal} onHide={handleModalClose}>
                  <Modal.Header closeButton>
                    <Modal.Title>Erro</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>{error}</Modal.Body>
                  <Modal.Footer>
                    <Button variant="secondary" onClick={handleModalClose}>
                      Fechar
                    </Button>
                  </Modal.Footer>
                </Modal>
              </div>
            </div>
          </div>
          <div className={styles.captcha_container}>
            <ReCAPTCHA
              sitekey={RECAPTCHA_SITE_KEY}
              ref={captchaRef}
              onChange={handleRecaptcha}
              onExpired={() => setRecaptchaToken(null)}
            />
          </div>
          
          <div className={styles.button}>
            <Button variant="flat" className={styles.save_btn} type="submit" disabled={!recaptchaToken ? true : false}>
              Enviar
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default ResetarSenha;
